function getConfigCompoment () { return 'YandexFactory' }
function getStandardAttributes () { return null }

export default {
  getConfigCompoment,
  getStandardAttributes
}
